import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "unauthorized" }

import { useAuth } from "@/composables/useAuth";


export default /*@__PURE__*/_defineComponent({
  __name: 'UnauthorizedView',
  setup(__props) {

const { logout } = useAuth();

function signOut() { 
  logout(); 
}

function openSettings() {
  // Navigate to settings route when it's implemented
  // For now, maintain existing behavior
  window.location.hash = "#/settings";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Contact your administrator to get authorized", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, "Your account does not currently have access to AgentPanels.", -1)),
    _createElementVNode("div", { class: "actions" }, [
      _createElementVNode("button", { onClick: openSettings }, "Settings"),
      _createElementVNode("button", { onClick: signOut }, "Sign Out")
    ])
  ]))
}
}

})